import type { AiProviderId } from '../api/rancho.api';

/** Orden por defecto de cada preset (espejo de AI_PROVIDER_PRESETS del backend). */
export const AI_PRESET_ORDER: Record<'COST' | 'SPEED', AiProviderId[]> = {
  SPEED: ['gemini', 'openai', 'groq', 'deepseek', 'cerebras', 'openrouter', 'cloudflare'],
  COST:  ['groq', 'cerebras', 'gemini', 'openrouter', 'deepseek', 'openai', 'cloudflare'],
};

/** Nombre de marca; el modelo real viene del backend (`models` en /admin/ai-status). */
export const AI_PROVIDER_BRANDS: Record<AiProviderId, string> = {
  gemini:   'Gemini',
  openai:   'OpenAI',
  groq:     'Groq',
  deepseek: 'DeepSeek',
  mistral:  'Mistral',
  cerebras:   'Cerebras',
  openrouter: 'OpenRouter',
  cloudflare: 'Cloudflare (audio)',
};

/** "Marca · modelo" cuando el backend ya informó el modelo; solo la marca mientras carga. */
export function providerLabel(id: AiProviderId | 'anthropic', models?: Partial<Record<string, string>>): string {
  const brand = id === 'anthropic' ? 'Anthropic Claude' : AI_PROVIDER_BRANDS[id];
  const model = models?.[id];
  return model ? `${brand} · ${model}` : brand;
}
